// Module
var code = "<img ng-src=\"{{ $ctrl.src }}\" alt=\"{{ $ctrl.name }}\" title=\"{{ $ctrl.name }}\" icon-src> ";
// Exports
export default code;